
import gif from "../../images/glowgif01.gif";


import staff from "../../images/staff1.png";
import e from "../../images/e.png";

import EastIcon from '@mui/icons-material/East';


import team from '../../images/team.png';

import bgImage2 from "../../images/glow.png";
import staffing from "../../images/staffing.jpg";
import './LoginPortal.css';
import { useNavigate } from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/pagination';
import React, { useEffect, useState, useRef } from 'react';



export const LoginPortal = () => {
  const navigate = useNavigate();
  const scrollToTop = () => {
    window.scrollTo(0, 0);
}
  const [width, setWidth] = useState(window.innerWidth);
  const heroRef = useRef<HTMLDivElement | null>(null);
  const backgroundRef = useRef<HTMLDivElement | null>(null);
 
  const handleButtonClick1 = () => {
    // console.log("butto nnnnn");
    const url = " https://intellesphere-lms.moodlecloud.com/"; // Replace with your desired URL
    window.open(url, "_blank", "noopener,noreferrer");
    
  };
  const handleButtonClick2 = () => {
    // console.log("butto nnnnn");
    const url = "https://internship.skillciti.com/"; // Replace with your desired URL
    window.open(url, "_blank", "noopener,noreferrer");
    
  };
 
  useEffect(() => {
    if (heroRef.current && backgroundRef.current) {
      heroRef.current.style.background = 'none';
      backgroundRef.current.style.backgroundImage = `url(${bgImage2})`;
    }
    const handleScroll = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = maxScaleTop;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.transformOrigin = 'bottom right';
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-26.47 * scaleside) + 36.47}%`;
      }
    };
    const handleScrollMobile = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = 1.8;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        // backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.txransformOrigin = 'bottom right';
        // backgroundRef.current.style.top = `${(-22.05 * scaleTop) + 47}%`;
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-30.47 * scaleside) + 26.47}%`;
      }
    };
    const updateScrollHandler = () => {
      const isMobile = window.innerWidth <= 900; // Adjust breakpoint as needed
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
  
      if (isMobile) {
        window.addEventListener('scroll', handleScrollMobile);
      } else {
        window.addEventListener('scroll', handleScroll);
      }
    };
  
    // Set the initial scroll handler
    updateScrollHandler();
     // Update the scroll handler on resize
  window.addEventListener('resize', updateScrollHandler);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
      window.removeEventListener('resize', updateScrollHandler);
    };
}, []);


 
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="wrapper2">
    <section id='hero2' ref={heroRef} className="hero2"
    // style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'auto', background: 'cover' }}
    >
         <div   className='glow_2'></div>

<div ref={backgroundRef} className="background">
<div   ref={backgroundRef}className='glow'></div>
</div>
<div className="background2"></div>
      {/* <div ref={backgroundRef} className="background">
      Staffing
      </div> */}
      <div className='hero__flexL'  >
     
      
         <div className='hero__rightL'  >
         <div>
        <div className='rightbox_paragraph_up'>
     Login Portal
            </div>
            <a>-Intell<img src={e} className='elogo' />Sphere</a>
            </div>
           
            <div className='sevices_inL'>
         
         <div className='sevices_boxL'>
    
         <a>LMS Login</a>
        
         <p> Login to your LMS to access course data and resources using the Module ID and Password.
         </p>
        
         <div className='join_buttonL' onClick={handleButtonClick1}>
         Login 
         <EastIcon className='arrow' ></EastIcon>
         </div>
         
         </div>
         
         <div className='sevices_boxL'>
         <img
         // src={devops}
         className='animeImg'
         
         />
         <a>Internship Login</a>
        
         <p>Students given Student ID and Password to login to the intership program</p>
         
         <div className='join_buttonL' 
        //  onClick={() => window.open("https://internship.skillciti.com/", "_blank", "noopener,noreferrer")}
         onClick={handleButtonClick2}
         >
         Login
         <EastIcon className='arrow' ></EastIcon>
         </div>
         </div>
    
  
         {/* <img
         src={Tlogo}
         className='imageSide'
         
         /> */}
        </div>
           
           
         </div>
      
      </div>
    </section>

   
    
   
          
    </div>
    
    
  )
}






